var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M382.31 103.3c-27.76-18.1-47.79-47.07-54.04-80.82-1.35-7.29-2.1-14.8-2.1-22.48h-88.6l-.15 355.09c-1.48 39.77-34.21 71.68-74.33 71.68-12.47 0-24.21-3.11-34.55-8.56-23.71-12.47-39.94-37.32-39.94-65.91 0-41.07 33.42-74.49 74.48-74.49 7.67 0 15.02 1.27 21.97 3.44V190.8c-7.2-.99-14.51-1.59-21.97-1.59C73.16 189.21 0 262.36 0 352.3c0 55.17 27.56 104 69.63 133.52 26.48 18.61 58.71 29.56 93.46 29.56 89.93 0 163.08-73.16 163.08-163.08V172.23c34.75 24.94 77.33 39.64 123.28 39.64v-88.61c-24.75 0-47.8-7.35-67.14-19.96z"}));
}

Tiktok.defaultProps = {"width":"24","fill":"#3A2A55","shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality","fillRule":"evenodd","clipRule":"evenodd","viewBox":"0 0 449.45 515.38"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
